export function generateDemoData() {
  const demoPage = {
    id: 1001,
    name: "Premium Кешбэк",
    description: "Сканируй QR на кассе, получай бонусы и свяжись через Max/Telegram",
    image: "https://placehold.co/400x140?text=Loyalty+Card",
    logo: "💎 PremiumClub",
    shortUrl: "qrrun.ru/prem1",
    utmSource: "qr_cashier",
    utmMedium: "qr_physical",
    utmCampaign: "summer_cash",
    tags: [],
    createdAt: "05.04.2025",
    status: "active",
  };

  const names = ["Алексей Смирнов", "Мария Козлова", "Дмитрий Иванов", "Елена Морозова", "Олег Новиков", "Анна Ветрова", "Виктор Логинов"];
  const sources = ["Max", "Telegram", "СМС"];

  const demoVisits = [];
  for (let i = 0; i < 12; i++) {
    const name = names[Math.floor(Math.random() * names.length)];
    const date = new Date();
    date.setDate(date.getDate() - Math.floor(Math.random() * 7));
    const dateStr = date.toLocaleDateString('ru-RU');
    const timeStr = `${10 + Math.floor(Math.random() * 12)}:${Math.floor(Math.random() * 60).toString().padStart(2, '0')}`;
    const targetReached = i % 4 !== 0;
    demoVisits.push({
      id: `2000-${i}`,
      pageId: 1001,
      ip: `${Math.floor(10 + Math.random() * 240)}.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}.${Math.floor(Math.random() * 255)}`,
      avatar: `https://ui-avatars.com/api/?background=0f4c81&color=fff&name=${encodeURIComponent(name)}&size=32&rounded=true`,
      fullName: name,
      phone: `+7${Math.floor(9000000000 + Math.random() * 1000000000)}`,
      sourceType: targetReached ? sources[i % 3] : null,
      date: dateStr,
      time: timeStr,
      targetReached,
      clickTarget: targetReached,
    });
  }

  return { campaigns: [demoPage], visits: demoVisits };
}